import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Send, Phone, CheckCircle2 } from 'lucide-react';
export function QuoteCTA() {
  const [submitted, setSubmitted] = useState(false);
  const [form, setForm] = useState({
    name: '',
    phone: '',
    address: '',
    message: ''
  });
  function update(field: keyof typeof form) {
    return (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => setForm(f => ({
      ...f,
      [field]: e.target.value
    }));
  }
  function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setSubmitted(true);
  }
  return <section id="quote" className="relative overflow-hidden bg-navy-950 py-20 sm:py-24" data-id="element-128" data-mp="32kiwbb057avh">
      <div className="pointer-events-none absolute -top-24 left-1/4 h-80 w-80 rounded-full bg-brand-blue/20 blur-[120px]" data-id="element-129" data-mp="32i4xcr2cdein" />
      <div className="pointer-events-none absolute bottom-0 right-1/4 h-72 w-72 rounded-full bg-brand-cyan/15 blur-[110px]" data-id="element-130" data-mp="185ydz4zanrf9" />

      <div className="relative mx-auto grid max-w-7xl items-center gap-12 px-4 sm:px-6 lg:grid-cols-2" data-id="element-131" data-mp="138oq3trjzntj">
        <div data-id="element-132" data-mp="2l4gdin7dws5p">
          <p className="mb-3 text-sm font-semibold uppercase tracking-[0.2em] text-brand-cyan" data-id="element-133" data-mp="2l4ye1w12xsjf">
            Get Started
          </p>
          <h2 className="font-heading text-3xl font-extrabold tracking-tight text-white sm:text-4xl" data-id="element-134" data-mp="2v1b50m58psah">
            Request your free quote & water test
          </h2>
          <p className="mt-4 max-w-lg text-base leading-relaxed text-white/70" data-id="element-135" data-mp="2ztcgi5ul3ezg">
            Tell us a bit about your home and we&apos;ll reach out with honest pricing and a
            recommendation tailored to Tulsa water — no pressure, ever.
          </p>
          <div className="mt-8 space-y-4" data-id="element-136" data-mp="3drj6z0x7ecp3">
            <a href="tel:+19185550123" className="flex items-center gap-3 text-white" data-id="element-137" data-mp="3dppxzez4bgdx">
              <span className="flex h-11 w-11 items-center justify-center rounded-full bg-white/10" data-id="element-138" data-mp="3iq47l1gdaye2">
                <Phone className="h-5 w-5 text-brand-cyan" data-id="element-139" data-mp="1jfmagtjwmgn6" />
              </span>
              <span data-id="element-140" data-mp="1odnubgp5mjzp">
                <span className="block text-xs uppercase tracking-wide text-white/60" data-id="element-141" data-mp="1od4imhq3kru4">Call us today</span>
                <span className="font-bold" data-id="element-142" data-mp="1ge9eb82711vg">(918) 555-0123</span>
              </span>
            </a>
          </div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-60px'
      }} transition={{
        duration: 0.55
      }} className="rounded-3xl border border-white/10 bg-white p-6 shadow-2xl sm:p-8" data-id="element-143" data-mp="1qa30lj5ps9qf">
          {submitted ? <div className="flex flex-col items-center justify-center py-12 text-center" data-id="element-144" data-mp="1uawo4bf8vmis">
              <CheckCircle2 className="h-14 w-14 text-emerald-500" data-id="element-145" data-mp="2913w1x7mln58" />
              <h3 className="mt-4 font-heading text-xl font-extrabold text-navy-900" data-id="element-146" data-mp="241r796x72600">
                Thanks, {form.name || 'friend'}!
              </h3>
              <p className="mt-2 max-w-sm text-sm text-slate-600" data-id="element-147" data-mp="2i2218itsw0pe">
                Your request is in. A Tulsa Water Pros specialist will reach out shortly to schedule
                your free water test.
              </p>
            </div> : <form onSubmit={handleSubmit} className="space-y-4" data-id="element-148" data-mp="31n2cj0xwqygn">
              <div className="grid gap-4 sm:grid-cols-2" data-id="element-149" data-mp="31l7wo11htwjf">
                <Field label="Full name" required data-id="element-150" data-mp="2nmhrrz8fmski">
                  <input required value={form.name} onChange={update('name')} placeholder="Jane Smith" className={inputCls} data-id="element-151" data-mp="2npvvpbwqv9u2" />
                </Field>
                <Field label="Phone" required data-id="element-152" data-mp="2iq10wx9um03q">
                  <input required type="tel" value={form.phone} onChange={update('phone')} placeholder="(918) 555-0123" className={inputCls} data-id="element-153" data-mp="24xbg2w623187" />
                </Field>
              </div>
              <Field label="Home address" data-id="element-154" data-mp="1zwx5b6d2ld6h">
                <input value={form.address} onChange={update('address')} placeholder="Street, City, OK" className={inputCls} data-id="element-155" data-mp="2001fckd7v352" />
              </Field>
              <Field label="What can we help with?" data-id="element-156" data-mp="2tijazsv7gsj3">
                <textarea value={form.message} onChange={update('message')} rows={3} placeholder="Hard water, chlorine taste, drinking water…" className={`${inputCls} resize-none`} data-id="element-157" data-mp="2th8b444vs4x9" />
              </Field>
              <button type="submit" className="inline-flex w-full items-center justify-center gap-2 rounded-full bg-brand-cyan px-6 py-3.5 text-base font-bold text-white shadow-lg shadow-brand-cyan/25 transition-colors hover:bg-brand-blue" data-id="element-158" data-mp="2enwkkfyaf60m">
                <Send className="h-4 w-4" data-id="element-159" data-mp="8s2aoxumcpdu" />
                Get My Free Quote
              </button>
              <p className="text-center text-xs text-slate-400" data-id="element-160" data-mp="3uiqzif5jkei">
                No spam. We&apos;ll only use your info to prepare your quote.
              </p>
            </form>}
        </motion.div>
      </div>
    </section>;
}
const inputCls = 'w-full rounded-xl border border-slate-200 bg-slate-50 px-4 py-3 text-sm text-navy-900 placeholder:text-slate-400 focus:border-brand-blue focus:bg-white focus:outline-none focus:ring-2 focus:ring-brand-cyan/30';
function Field({
  label,
  required,
  children
}: {
  label: string;
  required?: boolean;
  children: React.ReactNode;
}) {
  return <label className="block" data-id="element-161" data-mp="3tj4y6rq20gdd">
      <span className="mb-1.5 block text-sm font-semibold text-navy-900" data-id="element-162" data-mp="2clhivxjdw75">
        {label} {required && <span className="text-brand-blue" data-id="element-163" data-mp="6e6zgvoxh0o7">*</span>}
      </span>
      {children}
    </label>;
}